/* eslint-disable max-len */
import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {Tooltip} from '@mui/material';
import moment from 'moment';
import './AttentionsHistory.scss';
import React, {useEffect, useRef, useState} from 'react';
import _ from 'lodash';
import CustomAlert from '../../common/components/Alert/CustomAlert';
import Loading from '../../common/components/Loading/Loading';
import Table from '../../common/components/ItemTable/v2/Table';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import Search from '../../assets/icons/Search';
import Chip from '../../common/components/Chip/v2/Chip';
import Trash from '../../assets/icons/Trash';
import _Modal from '../../common/components/Modal/v2/Modal';
import Button from '../../common/components/Button/Button';
import Loader from '../../assets/animations/Loader';
import AttentionHistoryExcelDownloadButton from './components/AttentionHistoryExcelDownloadButton';
import GroupedAttentionsList from './components/GroupedAttentionsList';
import Check from '../../assets/icons/Check';
import Cancel from '../../assets/icons/Cancel';
import CustomSelect from '../../common/components/CustomSelect/CustomSelect';
import Toggle from '../../common/components/Toggle/Toggle';
import {deleteExtraSpaces} from '../../utils/util';
import {getAttentionHistoryColumns} from './attentionHistoryColumns';
import {ATTENTION_HISTORY_DOWNLOAD_HEADERS} from './attentionHistoryExcel.headers';


const _AttentionsHistory = (props) => {
    const {
        name,
        switchOfUser,
        getAllAttentions,
        allAttentions,
        getAllAttentionsState,
        getAllAttentionsToDownload,
        role,
        deleteAttention,
        attentionsListConfig,
        setListConfig,
        cleanListConfig,
        attentionsToDownload,
        attentionsToDownloadState,
        deletedAttentionState,
        clearDeleteAttentionState,
        getBranches,
        branches,
        getBranchesProviders,
        branchesProviders,
        getBranchesState,
        getBranchesProvidersState,
        salesforceProviderId,
        cleanBranches,
        cleanProvidersBranches,
    } = props;

    const filters = [
        {value: 'today', label: 'Hoy'},
        {value: 'lastWeek', label: 'Últimos 7 días'},
        {value: 'lastMonth', label: 'Mes actual'},
    ];

    const tooltip = (attention) => {
        const isAffiliateMissing = attention.affiliateFullName === undefined;
        const displayName = isAffiliateMissing ? attention.accountFullName : attention.affiliateFullName;
        const tooltipValue = isAffiliateMissing ?
            `DNI: ${attention.accountDocument || ''}` :
            attention.numbers;

        return (
            <Tooltip title={tooltipValue}>
                <p className={'body-3 v2-c-text-title'}>
                    {displayName}
                </p>
            </Tooltip>
        );
    };

    const tooltipCode = (attention) => {
        return (
            <Tooltip
                title={<span>DESCRIPCIÓN: {attention.medicalServiceName || 'No disponible'}<br/>
                CÓDIGO: {attention.medicalServiceCode || 'No disponible'}</span>}>
                <p className={'body-3 v2-c-text-title'}>{attention.medicalServiceName}</p>
            </Tooltip>
        );
    };

    const tooltipDate = (attention) => {
        const date = new Date(attention.createdDate);
        const formattedDate = date.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        });
        const formattedTime = date.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit',
        });
        const parsedDate = `${formattedDate} ${formattedTime}`;
        return (
            <Tooltip title={parsedDate}>
                <p className={'body-3 v2-c-text-title'}>{parsedDate}</p>
            </Tooltip>
        );
    };

    const deleteAttentionBtn = (attention) => {
        const canCancel = checkIfCanCancelAttention(attention.createdDate);
        return (canCancel &&
            <div className={'flex-aligned-justified-center cursor-pointer'}
                 onClick={() => {
                     handleDelete(attention);
                 }}
            >
                <Trash width={'14px'} height={'14px'}/>
            </div>
        );
    };

    const checkIfCanCancelAttention = (createdDate) => {
        // if (diffYears > 1) return false;
        // if (diffYears === 0 && diffMonth === 0) {
        //     return true;
        // }
        // if (diffYears === 1 && month === 12 && actualMonth === 1 && actualDay <= 15) {
        //     return true;
        // }
        // if (diffYears === 0 && diffMonth === 1 && actualDay <= 15) {
        //     return true;
        // }
        return moment(createdDate).isSame(Date.now(), 'day');
    };

    const [showModal, setShowModal] = useState(false);
    const [modalButtonAction, setModalButtonAction] = useState(null);
    const [modalInfo, setModalInfo] = useState({});
    const [search, setSearch] = useState('');
    const [searchTag, setSearchTag] = useState('affiliateLastName');
    const [filter, setFilter] = useState();
    const [items, setItems] = useState([]);
    const [listData, setListData] = useState([]);
    const [tagNames, setTagNames] = useState({});
    const [branchesOptions, setBranchesOptions] = useState([]);
    const [branchesProvidersOptions, setBranchesProvidersOptions] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchIdToAddress, setBranchIdToAddress] = useState({});
    const [isGrouped, setIsGrouped] = useState(false);

    const commonTagNames = {
        affiliateLastName: 'Afiliado',
        medicalServiceName: 'Atención',
        affiliateDocument: 'Documento de afiliado',
        dateFrom: 'Fecha desde',
        dateTo: 'Fecha hasta',
    };
    const [currentPage, setCurrentPage] = useState(-1);

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [pageQuantity, setPageQuantity] = useState(Math.ceil(allAttentions?.totalCount));

    // const pageQuantity = ;

    const isInitialMount = useRef(true);

    const handleChangeRowsPerPage = (pageSize) => {
        setRowsPerPage(parseInt(pageSize, 10));
    };

    const handleClose = () => {
        setShowModal(false);
        clearDeleteAttentionState();
    };

    const handleDelete = (attention) => {
        setModalButtonAction(() => () => handleClickDelete(attention));
        setModalInfo({
            title: 'Eliminar atención',
            buttonText: 'Eliminar',
            text: `¿Está seguro que desea eliminar la atención ${attention.medicalServiceName}?`,
        });
        setShowModal(true);
    };

    const handleClickDelete = (attention) => {
        const body = {
            attentionId: attention.attentionId,
        };
        deleteAttention(body);
        handleClose();
    };

    const restarUnaSemana = (fechaActual) => {
        const nuevaFecha = new Date(fechaActual);

        nuevaFecha.setDate(nuevaFecha.getDate() - 7);

        const año = nuevaFecha.getFullYear();
        const mes = (nuevaFecha.getMonth() + 1).toString().padStart(2, '0');
        const dia = nuevaFecha.getDate().toString().padStart(2, '0');
        const fechaFormateada = `${año}-${mes}-${dia}`;

        return fechaFormateada;
    };

    const obtenerInicioMesActual = () => {
        const ahora = new Date();
        const año = ahora.getFullYear();
        const mes = (ahora.getMonth() + 1).toString().padStart(2, '0'); // Mes actual (01-12)
        return `${año}-${mes}-01`;
    };

    const obtenerFechaHoy = () => {
        const ahora = new Date();
        const año = ahora.getFullYear();
        const mes = (ahora.getMonth() + 1).toString().padStart(2, '0');
        const dia = ahora.getDate().toString().padStart(2, '0');
        return `${año}-${mes}-${dia}`;
    };

    const formatearFechaParaPill = (fecha) => {
        if (!fecha) return '';
        const partes = fecha.split('-');
        if (partes.length === 3) {
            return `${partes[2]}-${partes[1]}-${partes[0]}`;
        }
        return fecha;
    };

    const isDateFilterActive = (filterValue) => {
        const searchTags = attentionsListConfig?.searchTags;
        if (!searchTags || !searchTags.dateFrom || !searchTags.dateTo) {
            return false;
        }

        // Convert display format dates back to API format for comparison
        const convertDisplayToApi = (dateStr) => {
            if (!dateStr) return '';
            // Check if it's in DD-MM-YYYY format
            const parts = dateStr.split('-');
            if (parts.length === 3 && parts[0].length === 2 && parts[2].length === 4) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateStr;
        };

        const storedDateFrom = convertDisplayToApi(searchTags.dateFrom);
        const storedDateTo = convertDisplayToApi(searchTags.dateTo);

        // Calculate expected values for each filter
        const today = obtenerFechaHoy();
        const lastWeekFrom = restarUnaSemana(new Date());
        const lastWeekTo = new Date().toISOString().split('T')[0];
        const currentMonthFrom = obtenerInicioMesActual();
        const currentMonthTo = new Date().toISOString().split('T')[0];

        // Check if current filter matches the expected date range
        if (filterValue === 'today') {
            return storedDateFrom === today && storedDateTo === today;
        } else if (filterValue === 'lastWeek') {
            return storedDateFrom === lastWeekFrom && storedDateTo === lastWeekTo;
        } else if (filterValue === 'lastMonth') {
            return storedDateFrom === currentMonthFrom && storedDateTo === currentMonthTo;
        }

        return false;
    };

    const handleSearch = () => {
        const searchValue = search;
        const searchTagValue = searchTag || 'medicalServiceName';

        // Don't proceed if it's a date field and no value is provided
        if ((searchTag === 'dateFrom' || searchTag === 'dateTo') && !searchValue) {
            return;
        }

        // For dateTo, adjust to include the full day but only show the date in the pill
        let adjustedSearchValue = searchValue;
        const displayValue = searchValue;
        if (searchTag === 'dateTo') {
            const date = new Date(searchValue);
            date.setUTCHours(23, 59, 59, 999);
            adjustedSearchValue = date;
        }

        // Handle all searches uniformly
        const searchTags = {...attentionsListConfig.searchTags, [searchTagValue]: displayValue};
        setListConfig({
            list: 'attentionsListConfig',
            config: {search: adjustedSearchValue, searchTags, page: 1, size: rowsPerPage, grouped: isGrouped},
        });
        getAllAttentions();
        setSearch('');
    };

    useEffect(() => {
        switchOfUser('Historial atenciones');
        cleanListConfig('attentionsListConfig');
        cleanBranches();
        cleanProvidersBranches();
        setCurrentPage(1);

        setListData(getAttentionHistoryColumns(role, {
            attention: (params) => tooltipCode(params.row),
            date: (params) => tooltipDate(params.row),
            affiliate: (params) => tooltip(params.row),
            deleteAction: (params) => deleteAttentionBtn(params.row),
        }));

        switch (role) {
            case 'PROVIDER_ADMIN':
                setTagNames({...commonTagNames, protocolCode: 'Protocolo'});
                // Addresses will be loaded when providerAddress filter is selected
                break;
            case 'ADMIN':
                setTagNames({...commonTagNames, protocolCode: 'Protocolo', providerName: 'Prestador'});
                break;
            default:
                setTagNames(commonTagNames);
                break;
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (deletedAttentionState.success || deletedAttentionState.error) {
            const info = deletedAttentionState.success ?
                {title: 'Atención eliminada correctamente', content: <Check height={'44px'} width={'44px'}/>} :
                {
                    title: 'La atención no pudo ser eliminada',
                    text: 'El plazo para realizar esta acción ha expirado',
                    content: <Cancel height={'44px'} width={'44px'} color={'#AB5035'}/>,
                };
            setModalInfo(info);
            setShowModal(true);
        }
    }, [deletedAttentionState]);

    useEffect(() => {
        if (!isInitialMount.current || attentionsListConfig === undefined) {
            setListConfig({
                list: 'attentionsListConfig',
                config: {page: currentPage, size: rowsPerPage, grouped: isGrouped},
            });
            getAllAttentions();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage, rowsPerPage]);

    useEffect(() => {
        if (currentPage > pageQuantity) setCurrentPage(pageQuantity);
        setPageQuantity(Math.ceil(allAttentions?.totalCount));
        // eslint-disable-next-line
    }, [allAttentions]);

    useEffect(() => {
        if (allAttentions?.isGrouped) {
            // For grouped data, we don't need to set items for the main table
            // The GroupedAttentionsList component handles its own data
            setItems([]);
        } else if (Array.isArray(allAttentions)) {
            // For non-grouped data, process the array as before
            setItems(allAttentions.map((attention) => ({...attention, id: attention.attentionId})));
        } else {
            // Fallback for when allAttentions is not an array
            setItems([]);
        }
        setPageQuantity(Math.ceil(allAttentions?.totalCount));
    }, [allAttentions, getAllAttentionsState.success]);

    // Add provider and sede filters for ADMIN role
    useEffect(() => {
        const tagNamesForRole = {...commonTagNames};
        if (role === 'ADMIN') {
            tagNamesForRole.protocolCode = 'Protocolo';
            tagNamesForRole.providerName = 'Prestador';
            tagNamesForRole.providerAddress = 'Sede';
        } else if (role === 'PROVIDER_ADMIN') {
            tagNamesForRole.protocolCode = 'Protocolo';
            tagNamesForRole.providerAddress = 'Sede';
        }
        setTagNames(tagNamesForRole);
    }, [role]);

    const handleFilterChange = (value) => {
        setSearchTag(value);

        if (role === 'PROVIDER_ADMIN') {
            // For PROVIDER_ADMIN, always ensure branches are loaded
            if (salesforceProviderId) {
                getBranchesProviders(salesforceProviderId);
            }
        } else if (role === 'ADMIN') {
            // Clear provider and sede selections when switching filters
            if (value !== 'providerAddress' && value !== 'providerName') {
                setSelectedProvider(null);
                setSelectedBranch(null);
                setBranchesProvidersOptions([]);
                setBranchesOptions([]);
                cleanProvidersBranches();
            } else if (value === 'providerAddress') {
                // Reset selections but load providers list
                setSelectedProvider(null);
                setSelectedBranch(null);
                setBranchesProvidersOptions([]);
                getBranches();
            }
        }
    };

    const handleProviderAddressSearch = (selectedValue, isProvider = false) => {
        if (isProvider) {
            setSelectedProvider(selectedValue);
            setSelectedBranch(null);
            // Always remove providerAddress from searchTags when selecting a provider
            const providerOption = branchesOptions.find((option) => option.value === selectedValue);
            const providerName = providerOption?.label || '';
            const searchTags = {
                ...attentionsListConfig?.searchTags,
                providerName: providerName,
            };
            delete searchTags.providerAddress;
            if (selectedValue) {
                console.log('[DEBUG] Provider selected:', selectedValue, providerName, searchTags);
                setListConfig({
                    list: 'attentionsListConfig',
                    config: {searchTags, page: 1, size: rowsPerPage, grouped: isGrouped},
                });
                getAllAttentions();
                getBranchesProviders(selectedValue);
            } else {
                const searchTags = _.omit(attentionsListConfig?.searchTags, ['providerName', 'providerAddress']);
                setListConfig({
                    list: 'attentionsListConfig',
                    config: {searchTags, page: 1, size: rowsPerPage, grouped: isGrouped},
                });
                getAllAttentions();
                setBranchesProvidersOptions([]);
            }
            return;
        } else {
            setSelectedBranch(selectedValue);
            if (selectedValue) {
                let searchTags = {...attentionsListConfig?.searchTags};
                if (role === 'ADMIN') {
                    const providerOption = branchesOptions.find((option) => option.value === selectedProvider);
                    const providerName = providerOption?.label || '';
                    searchTags = {
                        ...searchTags,
                        providerName: providerName,
                        providerAddress: selectedValue, // branchId
                    };
                } else {
                    searchTags = {
                        ...searchTags,
                        providerAddress: selectedValue, // branchId
                    };
                }
                console.log('[DEBUG] Sede selected:', selectedValue, branchesProvidersOptions, searchTags);
                setListConfig({
                    list: 'attentionsListConfig',
                    config: {searchTags, page: 1, size: rowsPerPage, grouped: isGrouped},
                });
                getAllAttentions();
            } else {
                const searchTags = _.omit(attentionsListConfig?.searchTags, ['providerAddress']);
                setListConfig({
                    list: 'attentionsListConfig',
                    config: {searchTags, page: 1, size: rowsPerPage, grouped: isGrouped},
                });
                getAllAttentions();
            }
        }
    };

    const deleteSearchTag = (tag) => {
        let searchTags = {...attentionsListConfig?.searchTags};

        if (role === 'ADMIN') {
            if (tag === 'providerAddress') {
                // Only remove the sede filter, keep the provider filter and selection
                searchTags = _.omit(searchTags, ['providerAddress']);
                setSelectedBranch(null);
                // Keep the sede filter type selected
                setSearchTag('providerAddress');
                // If we have a provider selected, reload its branches
                if (selectedProvider) {
                    getBranchesProviders(selectedProvider);
                }
            } else if (tag === 'providerName') {
                // If removing provider, remove both provider and sede filters
                searchTags = _.omit(searchTags, ['providerAddress', 'providerName']);
                // Switch to sede filter view with fresh state
                handleFilterChange('providerAddress');
            } else {
                // Only remove the tag being deleted, do not clear provider/sede or call handleFilterChange
                searchTags = _.omit(searchTags, [tag]);
            }
        } else {
            searchTags = _.omit(searchTags, [tag]);
        }

        setListConfig({
            list: 'attentionsListConfig',
            config: {search: search, searchTags, grouped: isGrouped},
        });
        getAllAttentions();
        if (filter === 'lastWeek' || filter === 'lastMonth') {
            setFilter('');
        }
    };

    const handleCleanFilters = () => {
        cleanListConfig('attentionsListConfig');
        setFilter('');
        // Reset all provider/sede related state
        setSelectedProvider(null);
        setSelectedBranch(null);
        setBranchesProvidersOptions([]);
        setBranchesOptions([]);
        cleanProvidersBranches();
        setSearch('');
        // Switch to sede filter view with fresh state
        handleFilterChange('providerAddress');
        getAllAttentions();
    };

    const renderSearchInput = () => {
        if (searchTag === 'providerName') {
            return (
                <div className={'input-form-wrapper'}>
                    <CustomSelect
                        placeholder={'Seleccionar prestador'}
                        onChange={(value) => handleProviderAddressSearch(value, true)}
                        value={selectedProvider}
                        options={branchesOptions}
                        isSearchable={true}
                    />
                </div>
            );
        }
        return (
            <div className={'input-form-wrapper'}>
                <CustomInput
                    placeholder={`Buscar ${tagNames[searchTag] ? tagNames[searchTag].toLowerCase() : ''}...`}
                    value={search}
                    type={searchTag === 'dateFrom' || searchTag === 'dateTo' ? 'date' : 'text'}
                    max={searchTag === 'dateFrom' || searchTag === 'dateTo' ? new Date().toISOString().split('T')[0] : ''}
                    onChange={(value) => setSearch(value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            handleSearch();
                        }
                    }}
                    leftSlot={<Search style={{pointerEvents: 'none'}}/>}
                    rightSlot={
                        <span
                            className={'search-action'}
                            onClick={handleSearch}
                        >
                            Buscar
                        </span>
                    }
                />
            </div>
        );
    };

    // Clear provider/address selections when switching away from providerAddress filter
    useEffect(() => {
        if (searchTag !== 'providerAddress' && searchTag !== 'providerName') {
            setSelectedProvider(null);
            setSelectedBranch(null);
        }
    }, [searchTag]);

    const headers = ATTENTION_HISTORY_DOWNLOAD_HEADERS;

    useEffect(() => {
        if ((searchTag === 'dateFrom' || searchTag === 'dateTo') && search) {
            handleSearch();
        }
    }, [search, searchTag]);

    const handleFilterSelect = (value) => {
        if (value !== filter) {
            setFilter(value);

            let dateFrom;
            let dateTo;

            if (value === 'today') {
                dateFrom = obtenerFechaHoy();
                // For today, set dateTo to end of day (23:59:59.999)
                const today = new Date();
                today.setUTCHours(23, 59, 59, 999);
                dateTo = today;
            } else if (value === 'lastWeek') {
                dateFrom = restarUnaSemana(new Date());
                dateTo = new Date().toISOString().split('T')[0];
            } else {
                dateFrom = obtenerInicioMesActual();
                dateTo = new Date().toISOString().split('T')[0];
            }

            const searchTags = {
                ...attentionsListConfig.searchTags,
                dateFrom,
                dateTo: value === 'today' ? obtenerFechaHoy() : dateTo,
            };

            setListConfig({
                list: 'attentionsListConfig',
                config: {search: dateFrom, searchTags, page: 1, size: rowsPerPage, grouped: isGrouped},
            });

            getAllAttentions();
        }
    };

    const handleDownloadModal = () => {
        setModalButtonAction(() => () => {
            setShowModal(false);
        });
        setModalInfo({
            title: 'Superaste el límite de descarga',
            text: 'El máximo de atenciones a descargar es 2000. Por favor, filtra tu búsqueda. De lo contrario, se descargarán solo las 2000 atenciones más recientes.',
            buttonText: 'Entendido',
        });
        setShowModal(true);
    };

    const handleGroupedToggle = (value) => {
        const newGroupedValue = !value;
        setIsGrouped(newGroupedValue);
        // Update the list config to include the grouped parameter and reset page to 1
        const updatedConfig = {
            ...attentionsListConfig,
            grouped: newGroupedValue,
            page: 1,
        };
        setListConfig({
            list: 'attentionsListConfig',
            config: updatedConfig,
        });
        setCurrentPage(1);
        getAllAttentions();
    };

    // Set up branches options for ADMIN role
    useEffect(() => {
        console.log('Processing providers for ADMIN role:', branches);
        console.log('Total providers received:', branches?.length);
        console.log('getBranchesState:', getBranchesState);

        if (!branches || !Array.isArray(branches)) {
            console.log('No providers data available');
            setBranchesOptions([]);
            return;
        }

        // Each item is already a unique provider, no need to deduplicate
        const processedOptions = branches.map((provider) => ({
            value: provider.providerId.toString(),
            label: deleteExtraSpaces(provider.providerId === 'a1l2K000005fIfrQAE' ? 'Prestador sin sede' : provider.fullName),
        }));

        console.log('Processed provider options:', processedOptions);
        console.log('Total provider options created:', processedOptions?.length);

        setBranchesOptions(processedOptions);
    }, [branches, getBranchesState.success]);

    // Load addresses when providerAddress filter is selected
    useEffect(() => {
        if (searchTag === 'providerAddress') {
            if (role === 'PROVIDER_ADMIN' && salesforceProviderId) {
                console.log('PROVIDER_ADMIN: Loading addresses for provider ID:', salesforceProviderId);
                getBranchesProviders(salesforceProviderId);
            } else if (role === 'ADMIN') {
                console.log('ADMIN: Loading providers list');
                getBranches();
            }
        }
    }, [searchTag, role, salesforceProviderId, getBranches, getBranchesProviders]);

    // Set up branch providers options
    useEffect(() => {
        console.log('Processing branchesProviders data:', branchesProviders);
        console.log('getBranchesProvidersState:', getBranchesProvidersState);

        // Check if branchesProviders has a results array or is the array itself
        const branches = branchesProviders?.results || branchesProviders || [];
        console.log('Extracted branches array:', branches);

        const options = branches?.map((branch) => {
            console.log('Processing branch:', branch);
            return {value: branch.branchId, label: branch.fullName};
        }) || [];

        // Build branchId to address mapping
        const idToAddress = {};
        branches.forEach((branch) => {
            idToAddress[branch.branchId] = branch.fullName;
        });
        setBranchIdToAddress(idToAddress);
        setBranchesProvidersOptions(options);
    }, [branchesProviders, getBranchesProvidersState.success]);

    // When provider is selected, get its branches
    useEffect(() => {
        if (role === 'ADMIN' && selectedProvider) {
            console.log('ADMIN: Loading branches for selected provider:', selectedProvider);
            getBranchesProviders(selectedProvider);
            setSelectedBranch(null); // Reset branch selection
        }
    }, [selectedProvider, role, getBranchesProviders]);

    useEffect(() => {
        console.log('[DEBUG] attentionsListConfig changed:', attentionsListConfig);
    }, [attentionsListConfig]);

    return (
        <div className={'page-content-container'}>
            <div className={'attentions-history-header-container'}>
                <p className={'h3 v2-c-text-title'}>Historial Atenciones</p>
            </div>
            <div className={'page-table-container'}>
                <div className="page-table-options">
                    <div className={'attentions-history-filter-container'} style={{pointerEvents: getAllAttentionsState.loading ? 'none' : 'auto'}}>
                        <div className={'filters-row'}>
                            <div className={'filters-left-section'}>
                                <div className={'select-container'}>
                                    <CustomSelect
                                        placeholder={'Seleccionar filtro'}
                                        onChange={(value) => handleFilterChange(value)}
                                        value={searchTag}
                                        options={Object.keys(tagNames)
                                            .map((key) => ({
                                                value: key,
                                                label: tagNames[key],
                                                disabled: key === 'providerName' &&
                                                         Boolean(attentionsListConfig?.searchTags?.providerAddress) &&
                                                         searchTag !== 'providerAddress',
                                            }))}
                                    />
                                </div>
                                {searchTag === 'providerAddress' ? (
                                    <>
                                        {role === 'ADMIN' && (
                                            <div className={'select-container'}>
                                                <CustomSelect
                                                    placeholder={'Seleccionar prestador'}
                                                    onChange={(value) => handleProviderAddressSearch(value, true)}
                                                    value={selectedProvider}
                                                    options={branchesOptions}
                                                    isSearchable={true}
                                                />
                                            </div>
                                        )}
                                        {((role === 'ADMIN' && selectedProvider) || role === 'PROVIDER_ADMIN') && (
                                            <div className={'select-container'}>
                                                <CustomSelect
                                                    placeholder={'Seleccionar sede'}
                                                    onChange={(value) => handleProviderAddressSearch(value, false)}
                                                    value={selectedBranch}
                                                    options={branchesProvidersOptions}
                                                    isSearchable={true}
                                                />
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className={'input-container'}>
                                        {renderSearchInput()}
                                    </div>
                                )}
                            </div>
                            <div className={'download-button-container'}>
                                <div className={'buttons-stack'}>
                                    <Button
                                        size={'small'}
                                        onClick={handleCleanFilters}
                                        disabled={!attentionsListConfig?.searchTags || Object.keys(attentionsListConfig?.searchTags).length === 0}
                                    >
                                        Limpiar filtros
                                    </Button>
                                    {!getAllAttentionsState.loading ? (
                                        isGrouped ? (
                                            <Button disabled={true} size={'small'}>Descargar</Button>
                                        ) : (
                                            <AttentionHistoryExcelDownloadButton
                                                headers={headers[role]}
                                                topRow={[
                                                    'FILTROS:',
                                                    ...Object.keys(attentionsListConfig?.searchTags || {}).map(
                                                        (key) => `${tagNames[key]}: ${attentionsListConfig.searchTags[key]}`,
                                                    ),
                                                ]}
                                                openModal={() => handleDownloadModal()}
                                                attentionsToDownloadState={attentionsToDownloadState}
                                                attentionsToDownload={attentionsToDownload}
                                                getAllAttentionsToDownload={getAllAttentionsToDownload}
                                                fileName={`ATENCIONES:${role === 'ADMIN' ? 'TODAS' : name}-FECHA DE EMISION:${new Date().toLocaleDateString()}`}
                                            />
                                        )
                                    ) : (
                                        <Button disabled={true} size={'small'}><Loader color={'#fff'} width={'14px'} height={'14px'}/></Button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={'pills-row'}>
                            <div className={'attentions-history-chip-container'}>
                                {attentionsListConfig?.searchTags && Object.keys(attentionsListConfig?.searchTags).map((key) => {
                                    let displayValue = attentionsListConfig?.searchTags[key];
                                    if (key === 'providerAddress' && branchIdToAddress[attentionsListConfig?.searchTags[key]]) {
                                        displayValue = branchIdToAddress[attentionsListConfig?.searchTags[key]];
                                    } else if (key === 'dateFrom' || key === 'dateTo') {
                                        displayValue = formatearFechaParaPill(displayValue);
                                    }
                                    return (
                                        <Chip
                                            key={key}
                                            text={tagNames[key] + ': ' + displayValue}
                                            deleteOnClick={() => deleteSearchTag(key)}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                        <div className={'date-filters-row'}>
                            <div className={'attentions-history-input-filter-container'} style={{pointerEvents: getAllAttentionsState.loading ? 'none' : 'auto'}}>
                                {filters.map((_filter) => {
                                    const isActive = isDateFilterActive(_filter.value);
                                    return (
                                        <Button
                                            key={_filter.value}
                                            size={'small'}
                                            disabled={false}
                                            className={`subtitle-3 c-text-subtitle ${isActive ? 'active-filter' : ''}`}
                                            onClick={() => handleFilterSelect(_filter.value)}
                                        >
                                            {_filter.label}
                                        </Button>
                                    );
                                })}
                            </div>
                            <div className={'grouped-toggle-container'} style={{pointerEvents: getAllAttentionsState.loading ? 'none' : 'auto', marginLeft: 'auto'}}>
                                <div className={'toggle-label'}>
                                    <span className={'subtitle-3 c-text-subtitle'}>Agrupar</span>
                                    <Tooltip title="Agrupar por mismo afiliado, sede y fecha">
                                        <span className={'help-icon'} style={{
                                            marginLeft: '8px',
                                            cursor: 'pointer',
                                            color: '#666',
                                            fontSize: '12px',
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '50%',
                                            border: '1px solid #666',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            lineHeight: '1',
                                        }}>?</span>
                                    </Tooltip>
                                </div>
                                <Toggle value={isGrouped} handleChange={handleGroupedToggle} />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{height: '600px', overflow: 'hidden'}}>
                    {getAllAttentionsState.success ? (
                        allAttentions?.isGrouped ? (
                            allAttentions?.result && allAttentions.result.length > 0 && allAttentions.totalCount > 0 ? (
                                <GroupedAttentionsList
                                    groupedAttentions={allAttentions?.result || []}
                                    getAllAttentionsState={getAllAttentionsState}
                                    role={role}
                                    deleteAttention={deleteAttention}
                                    clearDeleteAttentionState={clearDeleteAttentionState}
                                    deletedAttentionState={deletedAttentionState}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    rowsPerPage={rowsPerPage}
                                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                                    pageQuantity={pageQuantity}
                                    listData={listData}
                                />
                            ) : (
                                <CustomAlert text={'No se encontraron atenciones'} severity='info'/>
                            )
                        ) : allAttentions?.totalCount > 0 ? (
                            <Table attributes={listData} rows={items} currentPage={currentPage}
                                   pageSizeOptions={[10, 25, 50, 100]}
                                   noRowsMessage={'No se encontraron atenciones'}
                                   onPageChange={(value) => setCurrentPage(value)} rowCount={allAttentions?.totalCount}
                                   pageSize={rowsPerPage} onPageSizeChange={(value) => handleChangeRowsPerPage(value)}/>
                        ) : (
                            <CustomAlert text={'No se encontraron atenciones'} severity='info'/>
                        )
                    ) : getAllAttentionsState.loading ? (
                        <Loading className="ul-div-sect-table"/>
                    ) : (
                        <CustomAlert text={'atenciones' || String(getAllAttentionsState.error)} severity='error'/>
                    )}
                </div>
                {showModal && (
                    <_Modal
                        showModal={showModal}
                        handleClose={handleClose}
                        handleClick={modalButtonAction}
                        modalText={modalInfo.text}
                        modalContent={modalInfo.content}
                        modalTitle={modalInfo.title}
                        modalButtonText={modalInfo.buttonText}
                    />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    allAttentions: state.home.allAttentions,
    getAllAttentionsState: state.home.getAllAttentionsState,
    attentionsListConfig: state.home.attentionsListConfig,
    role: state.login.userInfo.role.name,
    attentionsToDownload: state.home.attentionsToDownload,
    deletedAttentionState: state.home.deletedAttentionState,
    attentionsToDownloadState: state.home.getAllAttentionsToDownloadState,
    branches: state.home.branches,
    branchesProviders: state.home.branchesProviders,
    getBranchesState: state.home.getBranchesState,
    getBranchesProvidersState: state.home.getBranchesProvidersState,
    salesforceProviderId: state.login.userInfo.salesforceProviderId,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    getAllAttentions: () => dispatch(actions.home.getAllAttentionsRequest()),
    getAllAttentionsToDownload: () => dispatch(actions.home.getAllAttentionsDownloadRequest()),
    deleteAttention: (body) => dispatch(actions.home.deleteAttentionRequest(body)),
    clearDeleteAttentionState: () => dispatch(actions.home.clearDeleteAttentionState()),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    selectPlan: (plan) => dispatch(actions.home.selectPlan(plan)),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    getBranchesProviders: (id) => dispatch(actions.home.getBranchesProvidersRequest(id)),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
});

_AttentionsHistory.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    allAttentions: PropTypes.array,
    getAllAttentionsState: PropTypes.object,
    attentionsToDownload: PropTypes.array,
    getAllAttentionsToDownloadState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(_AttentionsHistory);
